/**
 * Zdarzenie „file_download" w dataLayer dla każdego pobrania pliku oferty:
 * nazwa oferty i język pliku. Bez podłączonego GA4 / GTM tablica po prostu
 * zostaje na stronie — skrypt nie wymaga żadnej konfiguracji.
 */
document.addEventListener('click', event => {
    const link = event.target.closest('a[download], a[href$=".pdf" i]');

    if (!link) return;

    const named = link.closest('[data-download-name]');
    const language = link.getAttribute('hreflang')
        || document.documentElement.getAttribute('lang')
        || 'pl';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'file_download',
        offer_name: named ? named.dataset.downloadName : link.textContent.trim(),
        file_language: language.toLowerCase().split('-')[0],
        file_url: link.href,
    });
});
